module.exports = __webpack_public_path__ + "static/media/puzzle-left.4c03f7aa.png";